var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMysSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7392 8.00001H14.0001C14.0001 7.45844 13.9279 6.93386 13.7934 6.43478H7.7392V8.00001Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7392 4.86958H13.1194C12.7521 4.27023 12.2826 3.74048 11.735 3.30435H7.7392V4.86958Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 14C9.41209 14 10.71 13.5119 11.7349 12.6956H4.26508C5.29002 13.5119 6.58792 14 8.00001 14Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88067 11.1304H13.1194C13.4143 10.6493 13.6429 10.1234 13.7933 9.56522H2.20673C2.35712 10.1234 2.5858 10.6493 2.88067 11.1304Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8 4.68631 8 4.29566 8 2C4.68631 2 2 4.68631 2 8H8Z",
    fill: "#05057D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98988 7.13586C5.17046 7.13586 4.50619 6.47157 4.50619 5.65217C4.50619 4.83277 5.17048 4.16849 5.98988 4.16849C6.24537 4.16849 6.48577 4.2331 6.69565 4.34682C6.3664 4.02486 5.91612 3.82611 5.41923 3.82611C4.41073 3.82611 3.59314 4.64368 3.59314 5.6522C3.59314 6.66071 4.41073 7.47828 5.41923 7.47828C5.91612 7.47828 6.3664 7.27953 6.69565 6.95757C6.48577 7.07124 6.2454 7.13586 5.98988 7.13586Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40799 4.60867L6.6714 5.1595L7.26627 5.02206L6.99988 5.57142L7.47829 5.9508L6.88265 6.08507L6.88431 6.69564L6.40799 6.31366L5.93165 6.69564L5.93329 6.08507L5.33765 5.9508L5.81605 5.57142L5.54964 5.02206L6.14455 5.1595L6.40799 4.60867Z",
    fill: "#FFDA44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysSm);
export default __webpack_public_path__ + "static/media/MYS-SM.d7285e956fca1951653794af736ff4aa.svg";
export { ForwardRef as ReactComponent };